import * as moment from "moment";
import * as constants from "../utils/constants";
import * as utils from "../utils/utils";

/**
 * Ein Datentyp für Uhrzeiten.
 */
export class Time
{
    public get Hours(): number
    {
        return this.hours;
    }
    private hours: number;

    public get Minutes(): number
    {
        return this.minutes;
    }
    private minutes: number;

    public get Seconds(): number
    {
        return this.seconds;
    }
    private seconds: number;

    /**
     * Erstellt eine neue Instanz der Klasse Time.
     * @param hours Stunden
     * @param minutes Minuten
     * @param seconds Sekunden
     */
    constructor(hours: number, minutes: number, seconds: number)
    {
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
    }

    /**
     * Konvertiert die Uhrzeit in koordinierte Weltzeit.
     */
    public toUtc(): Time
    {
        var dateLocale: moment.Moment = moment().startOf("day");
        dateLocale.add(this.Hours, "hours").add(this.Minutes, "minutes").add(this.Seconds, "seconds");
        var dateUtc: moment.Moment = moment(dateLocale).utc();
        return new Time(dateUtc.hours(), dateUtc.minutes(), dateUtc.seconds());
    }

    /**
     * Konvertiert eine Uhrzeit in einen lesbaren string.
     * @param format Mögliche Formate: hh, hh:mm, hh:mm:ss
     */
    public toString(format?: string): string
    {
        switch (format)
        {
            case "hh":
                return this.Hours.padLeft(2, "0");
            case "hh:mm":
                return this.Hours.padLeft(2, "0") + ":" + this.Minutes.padLeft(2, "0");
        }

        return this.Hours.padLeft(2, "0") + ":" + this.Minutes.padLeft(2, "0") + ":" + this.Seconds.padLeft(2, "0");
    }

    /**
     * Konvertiert eine Uhrzeit in einen lesbaren kurzen string.
     * @returns Eine Uhrzeit in dem Format hh:mm
     */
    public toShortTimeString(): string
    {
        return this.Hours.padLeft(2, "0") + ":" + this.Minutes.padLeft(2, "0");
    }

    /**
     * Prüft ob zwei Uhrzeiten identisch sind.
     * @param obj Die Uhrzeit die mit dieser Uhrzeit verglichen werden soll.
     */
    public equals(obj: Time): boolean
    {
        return (this.Hours == obj.hours && this.Minutes == obj.Minutes && this.Seconds == obj.Seconds);
    }

    /**
     * Prüft ob diese Uhrzeit größer ist als die übergebene Uhrzeit.
     * @param obj Die Uhrzeit die mit dieser Uhrzeit verglichen werden soll.
     */
    public greaterThan(obj: Time): boolean
    {
        var val1: number = parseInt(this.toString().replace(":", ""));
        var val2: number = parseInt(obj.toString().replace(":", ""));
        return val1 > val2;
    }

    /**
     * Prüft ob diese Uhrzeit kleiner ist als die übergebene Uhrzeit.
     * @param obj Die Uhrzeit die mit dieser Uhrzeit verglichen werden soll.
     */
    public lessThan(obj: Time): boolean
    {
        var val1: number = parseInt(this.toString().replace(":", ""));
        var val2: number = parseInt(obj.toString().replace(":", ""));
        return val1 < val2;
    }


    public isEmpty(): boolean
    {
        if (this.Hours === 0 && this.Minutes === 0 && this.Seconds === 0)
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    /**
     * Parsed einen String in eine Uhrzeit.
     * @param value
     */
    public static parse(value: string): Time
    {
        if (value != null && value.match(constants.REGEX_TIME))
        {
            var timePieces = value.split(":");
            if (timePieces.length === 2)
            {
                return new Time(parseInt(timePieces[0]), parseInt(timePieces[1]), 0);
            }
            else if (timePieces.length === 3)
            {
                return new Time(parseInt(timePieces[0]), parseInt(timePieces[1]), parseInt(timePieces[2]));
            }
        }

        return null;
    }

    public static isValid(value: string): boolean
    {
        if (value != null && value.match(constants.REGEX_TIME))
        {
            return true
        }

        return false;
    }
}